import ModalComponent, { ModalProps } from '@molecules/BEOffScreen/Modal';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Image } from '@chakra-ui/react';
import Text from '@molecules/Text';
import styled from '@emotion/styled';

import imgPCI from '@view/assets/images/security-pci.png';
import imgSSL from '@view/assets/images/security-ssl.png';

const StyledModalContainer = styled.div`
    display: flex;
    gap: 24px;

    .images {
        display: flex;
        gap: 16px;

        @media screen and (max-width: 640px) {
            flex-direction: column;
        }
    }
`;

const ModalPaymentSecutity = (props: ModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalComponent
      {...props}
      width={640}
      title="Secure online payment"
      buttons={(props) => <></>}
    >
      <StyledModalContainer>
        <Box>
          <Text>
            Cloudbeds uses PCI-compliant security standards. All information
            transmitted is encrypted with a 128-bit SSL certificate. Payment
            information is stored within a vault, and only for a short period of
            time.
          </Text>
        </Box>
        <Box className="images">
          <Box>
            <Image src={imgPCI} minW="70px" />
          </Box>
          <Box>
            <Image src={imgSSL} minW="66px" />
          </Box>
        </Box>
      </StyledModalContainer>
    </ModalComponent>
  );
};

export default observer(ModalPaymentSecutity);
